<template>
  <v-dialog
    v-model="dialog"
    width="auto"
  >
    <div class="dialog-component">
      <v-card>
        <v-card-text v-html="replaceWithBr(cardText)">
        </v-card-text>

        <v-card-actions>
          <v-row>
            <v-col cols="12" sm="6" class="text-center">
              <v-btn
                :class="alertColor ? 'secondary-btn alert-color' : 'secondary-btn'"
                text
                @click="secondaryBtnClick"
              >
                {{ secondaryBtnText }}
              </v-btn>
            </v-col>
            <v-col cols="12" sm="6" class="text-center">
              <v-btn
                :class="alertColor ? 'main-btn alert-color' : 'main-btn'"
                @click="mainBtnClick"
              >
                {{ mainBtnText }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import { replaceWithBr } from '../../lib/helpers'

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    cardText: {
      type: String
    },
    mainBtnText: {
      type: String
    },
    secondaryBtnText: {
      type: String
    },
    alertColor: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      replaceWithBr
    }
  },
  methods: {
    mainBtnClick () {
      this.$emit('update:dialog', false)
      this.$emit('mainBtnCallback')
    },
    secondaryBtnClick () {
      this.$emit('update:dialog', false)
      this.$emit('secondaryBtnCallback')
    }
  }
}
</script>


// WEBPACK FOOTER //
// Dialog.vue?6fc1956f